

















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import logger from "@/configs/logger";
import * as api from "@/lib/api";
import getCallConfig from "@/helpers/getCallConfig";
import { User } from "@/types";
import { collections } from "@/configs/firebase";

@Component
export default class TransferCall extends Vue {
  @Action("transferCall") transferCall!: Function;
  @Prop() attributes!: any;
  @Prop() options!: string[];
  @State("user") user!: User;

  dialog = false;
  disabled = false;
  extraTransferOptions: string[] = [];
  timeoutRef!: number;

  @Watch("attributes")
  onTaskAtrributesUpdate(val: any) {
    if (val && val.transfer_status === "Accepted") {
      this.dialog = false;
    }
  }

  @Watch("disabled")
  onDisabledChange(val: boolean, prev: boolean) {
    if (val) {
      if (this.timeoutRef) {
        window.clearTimeout(this.timeoutRef);
      }
      this.timeoutRef = window.setTimeout(() => {
        this.disabled = false;
      }, 60000);
    }
  }

  mounted() {
    this.getAdditionalTransferOptions();
  }

  beforeDestroy() {
    if (this.timeoutRef) {
      window.clearTimeout(this.timeoutRef);
    }
  }

  async getAdditionalTransferOptions() {
    const tasks = [];
    if (this.user.groups.includes("customer_service")) {
      tasks.push(
        collections.user.where("groups", "array-contains", "customer_service")
      );
    }
    if (this.user.groups.includes("verification")) {
      tasks.push(
        collections.user.where("groups", "array-contains", "verification"),
        collections.user.where("groups", "array-contains", "fronter_t1")
      );
    }
    const snapshots = await Promise.all(tasks.map(task => task.get()));

    for (const snapshot of snapshots) {
      const options = snapshot.docs
        .map(doc => {
          let data = doc.data();
          return `agent:${data.email}`;
        })
        .filter(item => item !== `agent:${this.user.email}`);
      this.extraTransferOptions = [...this.extraTransferOptions, ...options];
    }
  }

  get transferOptions() {
    let options = getCallConfig(this.user.groups, this.attributes)
      .transferGroupOptions;
    if (Array.isArray(this.options) && this.options.length) {
      options = [...options, ...this.options];
    }
    return ["spanish_speaking_agent", ...this.extraTransferOptions, ...options];
  }

  async handleTransferCall(dest: string): Promise<void> {
    try {
      if (!dest) {
        this.$toasted.error("Transfer failed, no destination").goAway(2000);
        throw new Error("No transfer destination");
      }

      if (this.disabled) {
        this.$toasted.info("You can only transfer calls once per minute");
        return;
      }

      this.dialog = true;
      const taskAttributeKey = `task_attribute/${this.attributes.id}`;
      logger("log", `transfering call from ${taskAttributeKey} to ${dest}`);

      await api.transferCall(taskAttributeKey, dest);
      this.disabled = true;
    } catch (err) {
      this.dialog = false;
      logger("error", "transfer error", err);
      if (err.response && err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      }
    }
  }
}
